var ViewPort = {WIDTH: 0, HEIGHT: 0};

var IS_CORDOVA_APP = !!window.cordova;
var IS_TOUCH_DEVICE = (
    !!('ontouchstart' in window) || !!("onorientationchange" in window) || !!('ontouchstart' in document.documentElement) || !!window.ontouchstart 
        || !!window.onmsgesturechange || (window.DocumentTouch && window.document instanceof window.DocumentTouch)
);

var IS_DEV = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

var IS_MOBILE = false; //initiate as false
(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) {
    IS_MOBILE = true;
}
})(navigator.userAgent||navigator.vendor||window.opera||'');

const MILLIS_IN_MINUTE = 60 * 1000;
const MILLIS_IN_HOUR = 60 * MILLIS_IN_MINUTE;
const MILLIS_IN_A_DAY = 24 * MILLIS_IN_HOUR;

export const LOCAL_TZ_OFFSET_MILLIS = new Date().getTimezoneOffset() * 60000;

const WEB_PUSH_PUBLIC_KEY = "BOdNxyuUEKzdSB_JZr_YwDoWNc2DTSTLH0cI6DyJ_oulcjydmhrTVi9PQ17mVhmGmB7LURCAuRP_JUEMLWRv4PE";

const INT64_MAX = 9223372036854775807;

export {ViewPort, IS_TOUCH_DEVICE, IS_MOBILE, IS_DEV, MILLIS_IN_A_DAY, MILLIS_IN_HOUR, MILLIS_IN_MINUTE, WEB_PUSH_PUBLIC_KEY, INT64_MAX};


export const Constants = {
    TYPE_INBOX_MESSAGES: 12,
    TYPE_INBOX_ENTRY_ADDED: 13,

    //session stuff
    TYPE_SESSION_DATA: 14,
    TYPE_SESSIONS_LIST: 15,
    TYPE_SESSION_USERS_DATA: 22,

    //event types
    EVENT_ALLSPARK_MESSAGE_RECEIVED: 1,
    EVENT_BASE_DISPLAY_TEMPLATE_LOADED: 2,
    EVENT_USER_AVAILABLE: 3,


    INBOX_MESSAGE_TYPE_SESSION_ID: 1008,
    INBOX_MESSAGE_TYPE_SIMPLE_MESSAGE: 1003,
    INBOX_MESSAGE_TYPE_SPECIAL_MESSAGE: 1004,
    INBOX_MESSAGE_TYPE_SPECIAL_LONG_MESSAGE: 1005,
    INBOX_MESSAGE_TYPE_TEMPLATE: 1014,
    INBOX_MESSAGE_TYPE_NONE: 0,
    INBOX_MESSAGE_TYPE_USER_IS_TYPING: 555,
    INBOX_MESSAGE_TYPE_APP_MESSAGE: 1015,


    SESSION_USER_ADMIN: 10,
    SESSION_USER_MODERATOR: 15,
    SESSION_USER_GENERAL: 20,
    SESSION_USER_PENDING: 30,
    SESSION_USER_BANNED: 31,

    NOTIFICATION_FLAG_NONE: 10,
    NOTIFICATION_FLAG_MUTED: 11,
    NOTIFICATION_FLAG_ONLY_WHEN_TAGGED: 20,
    NOTIFICATION_FLAG_ALL: 30,
}


export const EMOJIS = '😁,😊,😂,❤️,🤣,👍,😭,🙏,😘,🥰,🎉,😍,💕,🥺,😅,🔥,☺️,🤦,♥️,🤷,🙄,😆,🤗,😉,🎂,🤔,👏,🙂,😳,🥳,😎,👌,💜,😔,💪,✨,💖,👀,😋,😏,😢,👉,💗,😩,💯,🌹,💞,🎈,💙,😃,😡,💐,😜,🙈,🤞,😄,🤤,🙌,🤪,❣️,😀,💋,💀,👇,💔,😌,💓,🤩,🙃,😬,😱,😴,🤭,🤓,🧐,😐,🌞,😒,😇,🌸,😈,🎶,✌️,🎊,🥵,😞,💚,☀️,🖤,💰,😚,👑,🎁,💥,🙋,☹️,😑,🥴,👈,💩,✅,🐶,🐕,🐩,🐾,🌻,🌷'.split(',');



export const COUNTRY_PHONE_CODES_LIST = [
	{ name: 'Afghanistan', dial_code: '+93', code: 'AF', flag: '🇦🇫' },
	{ name: 'Albania', dial_code: '+355', code: 'AL', flag: '🇦🇱' },
	{ name: 'Algeria', dial_code: '+213', code: 'DZ', flag: '🇩🇿' },
	{ name: 'AmericanSamoa', dial_code: '+1684', code: 'AS', flag: '🇦🇸' },
	{ name: 'Andorra', dial_code: '+376', code: 'AD', flag: '🇦🇩' },
	{ name: 'Angola', dial_code: '+244', code: 'AO', flag: '🇦🇴' },
	{ name: 'Anguilla', dial_code: '+1264', code: 'AI', flag: '🇦🇮' },
	{ name: 'Antarctica', dial_code: '+672', code: 'AQ', flag: '🇦🇶' },
	{ name: 'Antigua and Barbuda', dial_code: '+1268', code: 'AG', flag: '🇦🇬' },
	{ name: 'Argentina', dial_code: '+54', code: 'AR', flag: '🇦🇷' },
	{ name: 'Armenia', dial_code: '+374', code: 'AM', flag: '🇦🇲' },
	{ name: 'Aruba', dial_code: '+297', code: 'AW', flag: '🇦🇼' },
	{ name: 'Australia', dial_code: '+61', code: 'AU', preferred: true, flag: '🇦🇺' },
	{ name: 'Austria', dial_code: '+43', code: 'AT', flag: '🇦🇹' },
	{ name: 'Azerbaijan', dial_code: '+994', code: 'AZ', flag: '🇦🇿' },
	{ name: 'Bahamas', dial_code: '+1242', code: 'BS', flag: '🇧🇸' },
	{ name: 'Bahrain', dial_code: '+973', code: 'BH', flag: '🇧🇭' },
	{ name: 'Bangladesh', dial_code: '+880', code: 'BD', flag: '🇧🇩' },
	{ name: 'Barbados', dial_code: '+1246', code: 'BB', flag: '🇧🇧' },
	{ name: 'Belarus', dial_code: '+375', code: 'BY', flag: '🇧🇾' },
	{ name: 'Belgium', dial_code: '+32', code: 'BE', flag: '🇧🇪' },
	{ name: 'Belize', dial_code: '+501', code: 'BZ', flag: '🇧🇿' },
	{ name: 'Benin', dial_code: '+229', code: 'BJ', flag: '🇧🇯' },
	{ name: 'Bermuda', dial_code: '+1441', code: 'BM', flag: '🇧🇲' },
	{ name: 'Bhutan', dial_code: '+975', code: 'BT', flag: '🇧🇹' },
	{ name: 'Bolivia, Plurinational State of', dial_code: '+591', code: 'BO', flag: '🇧🇴' },
	{ name: 'Bosnia and Herzegovina', dial_code: '+387', code: 'BA', flag: '🇧🇦' },
	{ name: 'Botswana', dial_code: '+267', code: 'BW', flag: '🇧🇼' },
	{ name: 'Brazil', dial_code: '+55', code: 'BR', flag: '🇧🇷' },
	{ name: 'British Indian Ocean Territory', dial_code: '+246', code: 'IO', flag: '🇮🇴' },
	{ name: 'Brunei Darussalam', dial_code: '+673', code: 'BN', flag: '🇧🇳' },
	{ name: 'Bulgaria', dial_code: '+359', code: 'BG', flag: '🇧🇬' },
	{ name: 'Burkina Faso', dial_code: '+226', code: 'BF', flag: '🇧🇫' },
	{ name: 'Burundi', dial_code: '+257', code: 'BI', flag: '🇧🇮' },
	{ name: 'Cambodia', dial_code: '+855', code: 'KH', flag: '🇰🇭' },
	{ name: 'Cameroon', dial_code: '+237', code: 'CM', flag: '🇨🇲' },
	{ name: 'Canada', dial_code: '+1', code: 'CA', flag: '🇨🇦' },
	{ name: 'Cape Verde', dial_code: '+238', code: 'CV', flag: '🇨🇻' },
	{ name: 'Cayman Islands', dial_code: '+345', code: 'KY', flag: '🇰🇾' },
	{ name: 'Central African Republic', dial_code: '+236', code: 'CF', flag: '🇨🇫' },
	{ name: 'Chad', dial_code: '+235', code: 'TD', flag: '🇹🇩' },
	{ name: 'Chile', dial_code: '+56', code: 'CL', flag: '🇨🇱' },
	{ name: 'China', dial_code: '+86', code: 'CN', flag: '🇨🇳' },
	{ name: 'Christmas Island', dial_code: '+61', code: 'CX', flag: '🇨🇽' },
	{ name: 'Cocos (Keeling) Islands', dial_code: '+61', code: 'CC', flag: '🇨🇨' },
	{ name: 'Colombia', dial_code: '+57', code: 'CO', flag: '🇨🇴' },
	{ name: 'Comoros', dial_code: '+269', code: 'KM', flag: '🇰🇲' },
	{ name: 'Congo', dial_code: '+242', code: 'CG', flag: '🇨🇬' },
	{ name: 'Congo, The Democratic Republic of the', dial_code: '+243', code: 'CD', flag: '🇨🇩' },
	{ name: 'Cook Islands', dial_code: '+682', code: 'CK', flag: '🇨🇰' },
	{ name: 'Costa Rica', dial_code: '+506', code: 'CR', flag: '🇨🇷' },
	{ name: "Cote d'Ivoire", dial_code: '+225', code: 'CI', flag: '🇨🇮' },
	{ name: 'Croatia', dial_code: '+385', code: 'HR', flag: '🇭🇷' },
	{ name: 'Cuba', dial_code: '+53', code: 'CU', flag: '🇨🇺' },
	{ name: 'Cyprus', dial_code: '+357', code: 'CY', flag: '🇨🇾' },
	{ name: 'Czech Republic', dial_code: '+420', code: 'CZ', flag: '🇨🇿' },
	{ name: 'Curaçao', dial_code: '+599', code: 'CW', flag: '🇨🇼' },
	{ name: 'Canary Islands', dial_code: '+34', code: 'IC', flag: '🇮🇨' },
	{ name: 'Denmark', dial_code: '+45', code: 'DK', flag: '🇩🇰' },
	{ name: 'Djibouti', dial_code: '+253', code: 'DJ', flag: '🇩🇯' },
	{ name: 'Dominica', dial_code: '+1767', code: 'DM', flag: '🇩🇲' },
	{
	  name: 'Dominican Republic',
	  dial_code: '+1849',
	  code: 'DO',
	  flag: '🇩🇴',
	  country_code: '+1',
	  area_codes: ['849', '829', '809'],
	},
	{ name: 'Dominican Republic', dial_code: '+1829', code: 'DO2', flag: '🇩🇴', secondary: true },
	{ name: 'Dominican Republic', dial_code: '+1809', code: 'DO3', flag: '🇩🇴', secondary: true },
	{ name: 'Ecuador', dial_code: '+593', code: 'EC', flag: '🇪🇨' },
	{ name: 'Egypt', dial_code: '+20', code: 'EG', flag: '🇪🇬' },
	{ name: 'El Salvador', dial_code: '+503', code: 'SV', flag: '🇸🇻' },
	{ name: 'Equatorial Guinea', dial_code: '+240', code: 'GQ', flag: '🇬🇶' },
	{ name: 'Eritrea', dial_code: '+291', code: 'ER', flag: '🇪🇷' },
	{ name: 'Estonia', dial_code: '+372', code: 'EE', flag: '🇪🇪' },
	{ name: 'Ethiopia', dial_code: '+251', code: 'ET', flag: '🇪🇹' },
	{ name: 'Falkland Islands (Malvinas)', dial_code: '+500', code: 'FK', flag: '🇫🇰' },
	{ name: 'Faroe Islands', dial_code: '+298', code: 'FO', flag: '🇫🇴' },
	{ name: 'Fiji', dial_code: '+679', code: 'FJ', flag: '🇫🇯' },
	{ name: 'Finland', dial_code: '+358', code: 'FI', flag: '🇫🇮' },
	{ name: 'France', dial_code: '+33', code: 'FR', flag: '🇫🇷' },
	{ name: 'French Guiana', dial_code: '+594', code: 'GF', flag: '🇬🇫' },
	{ name: 'French Polynesia', dial_code: '+689', code: 'PF', flag: '🇵🇫' },
	{ name: 'Gabon', dial_code: '+241', code: 'GA', flag: '🇬🇦' },
	{ name: 'Gambia', dial_code: '+220', code: 'GM', flag: '🇬🇲' },
	{ name: 'Georgia', dial_code: '+995', code: 'GE', flag: '🇬🇪' },
	{ name: 'Germany', dial_code: '+49', code: 'DE', flag: '🇩🇪' },
	{ name: 'Ghana', dial_code: '+233', code: 'GH', flag: '🇬🇭' },
	{ name: 'Gibraltar', dial_code: '+350', code: 'GI', flag: '🇬🇮' },
	{ name: 'Greece', dial_code: '+30', code: 'GR', flag: '🇬🇷' },
	{ name: 'Greenland', dial_code: '+299', code: 'GL', flag: '🇬🇱' },
	{ name: 'Grenada', dial_code: '+1473', code: 'GD', flag: '🇬🇩' },
	{ name: 'Guadeloupe', dial_code: '+590', code: 'GP', flag: '🇬🇵' },
	{ name: 'Guam', dial_code: '+1671', code: 'GU', flag: '🇬🇺' },
	{ name: 'Guatemala', dial_code: '+502', code: 'GT', flag: '🇬🇹' },
	{ name: 'Guinea', dial_code: '+224', code: 'GN', flag: '🇬🇳' },
	{ name: 'Guinea-Bissau', dial_code: '+245', code: 'GW', flag: '🇬🇼' },
	{ name: 'Guyana', dial_code: '+592', code: 'GY', flag: '🇬🇾' },
	{ name: 'Haiti', dial_code: '+509', code: 'HT', flag: '🇭🇹' },
	{ name: 'Holy See (Vatican City State)', dial_code: '+379', code: 'VA', flag: '🇻🇦' },
	{ name: 'Honduras', dial_code: '+504', code: 'HN', flag: '🇭🇳' },
	{ name: 'Hong Kong', dial_code: '+852', code: 'HK', flag: '🇭🇰' },
	{ name: 'Hungary', dial_code: '+36', code: 'HU', flag: '🇭🇺' },
	{ name: 'Iceland', dial_code: '+354', code: 'IS', flag: '🇮🇸' },
	{ name: 'India', dial_code: '+91', code: 'IN', preferred: true, flag: '🇮🇳' },
	{ name: 'Indonesia', dial_code: '+62', code: 'ID', flag: '🇮🇩' },
	{ name: 'Iran, Islamic Republic of', dial_code: '+98', code: 'IR', flag: '🇮🇷' },
	{ name: 'Iraq', dial_code: '+964', code: 'IQ', flag: '🇮🇶' },
	{ name: 'Ireland', dial_code: '+353', code: 'IE', flag: '🇮🇪' },
	{ name: 'Israel', dial_code: '+972', code: 'IL', flag: '🇮🇱' },
	{ name: 'Italy', dial_code: '+39', code: 'IT', flag: '🇮🇹' },
	{
	  name: 'Jamaica',
	  dial_code: '+1876',
	  code: 'JM',
	  flag: '🇯🇲',
	  country_code: '+1',
	  area_codes: ['876', '658'],
	},
	{ name: 'Jamaica', dial_code: '+1658', code: 'JM2', flag: '🇯🇲', secondary: true },
	{ name: 'Japan', dial_code: '+81', code: 'JP', flag: '🇯🇵' },
	{ name: 'Jordan', dial_code: '+962', code: 'JO', flag: '🇯🇴' },
	{ name: 'Kazakhstan', dial_code: '+77', code: 'KZ', flag: '🇰🇿' },
	{ name: 'Kenya', dial_code: '+254', code: 'KE', flag: '🇰🇪' },
	{ name: 'Kiribati', dial_code: '+686', code: 'KI', flag: '🇰🇮' },
	{ name: "Korea, Democratic People's Republic of", dial_code: '+850', code: 'KP', flag: '🇰🇵' },
	{ name: 'Korea, Republic of', dial_code: '+82', code: 'KR', flag: '🇰🇷' },
	{ name: 'Kuwait', dial_code: '+965', code: 'KW', flag: '🇰🇼' },
	{ name: 'Kyrgyzstan', dial_code: '+996', code: 'KG', flag: '🇰🇬' },
	{ name: 'Kosovo', dial_code: '+383', code: 'XK', flag: '🇽🇰' },
	{ name: "Lao People's Democratic Republic", dial_code: '+856', code: 'LA', flag: '🇱🇦' },
	{ name: 'Latvia', dial_code: '+371', code: 'LV', flag: '🇱🇻' },
	{ name: 'Lebanon', dial_code: '+961', code: 'LB', flag: '🇱🇧' },
	{ name: 'Lesotho', dial_code: '+266', code: 'LS', flag: '🇱🇸' },
	{ name: 'Liberia', dial_code: '+231', code: 'LR', flag: '🇱🇷' },
	{ name: 'Libyan Arab Jamahiriya', dial_code: '+218', code: 'LY', flag: '🇱🇾' },
	{ name: 'Liechtenstein', dial_code: '+423', code: 'LI', flag: '🇱🇮' },
	{ name: 'Lithuania', dial_code: '+370', code: 'LT', flag: '🇱🇹' },
	{ name: 'Luxembourg', dial_code: '+352', code: 'LU', flag: '🇱🇺' },
	{ name: 'Macao', dial_code: '+853', code: 'MO', flag: '🇲🇴' },
	{ name: 'Macedonia, The Former Yugoslav Republic of', dial_code: '+389', code: 'MK', flag: '🇲🇰' },
	{ name: 'Madagascar', dial_code: '+261', code: 'MG', flag: '🇲🇬' },
	{ name: 'Malawi', dial_code: '+265', code: 'MW', flag: '🇲🇼' },
	{ name: 'Malaysia', dial_code: '+60', code: 'MY', flag: '🇲🇾' },
	{ name: 'Maldives', dial_code: '+960', code: 'MV', flag: '🇲🇻' },
	{ name: 'Mali', dial_code: '+223', code: 'ML', flag: '🇲🇱' },
	{ name: 'Malta', dial_code: '+356', code: 'MT', flag: '🇲🇹' },
	{ name: 'Marshall Islands', dial_code: '+692', code: 'MH', flag: '🇲🇭' },
	{ name: 'Martinique', dial_code: '+596', code: 'MQ', flag: '🇲🇶' },
	{ name: 'Mauritania', dial_code: '+222', code: 'MR', flag: '🇲🇷' },
	{ name: 'Mauritius', dial_code: '+230', code: 'MU', flag: '🇲🇺' },
	{ name: 'Mayotte', dial_code: '+262', code: 'YT', flag: '🇾🇹' },
	{ name: 'Mexico', dial_code: '+52', code: 'MX', flag: '🇲🇽' },
	{ name: 'Micronesia, Federated States of', dial_code: '+691', code: 'FM', flag: '🇫🇲' },
	{ name: 'Moldova, Republic of', dial_code: '+373', code: 'MD', flag: '🇲🇩' },
	{ name: 'Monaco', dial_code: '+377', code: 'MC', flag: '🇲🇨' },
	{ name: 'Mongolia', dial_code: '+976', code: 'MN', flag: '🇲🇳' },
	{ name: 'Montenegro', dial_code: '+382', code: 'ME', flag: '🇲🇪' },
	{ name: 'Montserrat', dial_code: '+1664', code: 'MS', flag: '🇲🇸' },
	{ name: 'Morocco', dial_code: '+212', code: 'MA', flag: '🇲🇦' },
	{ name: 'Mozambique', dial_code: '+258', code: 'MZ', flag: '🇲🇿' },
	{ name: 'Myanmar', dial_code: '+95', code: 'MM', flag: '🇲🇲' },
	{ name: 'Namibia', dial_code: '+264', code: 'NA', flag: '🇳🇦' },
	{ name: 'Nauru', dial_code: '+674', code: 'NR', flag: '🇳🇷' },
	{ name: 'Nepal', dial_code: '+977', code: 'NP', flag: '🇳🇵' },
	{ name: 'Netherlands', dial_code: '+31', code: 'NL', flag: '🇳🇱' },
	{ name: 'Caribbean Netherlands', dial_code: '+599', code: 'BQ', flag: '🇧🇶' },
	{ name: 'New Caledonia', dial_code: '+687', code: 'NC', flag: '🇳🇨' },
	{ name: 'New Zealand', dial_code: '+64', code: 'NZ', flag: '🇳🇿' },
	{ name: 'Nicaragua', dial_code: '+505', code: 'NI', flag: '🇳🇮' },
	{ name: 'Niger', dial_code: '+227', code: 'NE', flag: '🇳🇪' },
	{ name: 'Nigeria', dial_code: '+234', code: 'NG', flag: '🇳🇬' },
	{ name: 'Niue', dial_code: '+683', code: 'NU', flag: '🇳🇺' },
	{ name: 'Norfolk Island', dial_code: '+672', code: 'NF', flag: '🇳🇫' },
	{ name: 'Northern Mariana Islands', dial_code: '+1670', code: 'MP', flag: '🇲🇵' },
	{ name: 'Norway', dial_code: '+47', code: 'NO', flag: '🇳🇴' },
	{ name: 'Oman', dial_code: '+968', code: 'OM', flag: '🇴🇲' },
	{ name: 'Pakistan', dial_code: '+92', code: 'PK', flag: '🇵🇰' },
	{ name: 'Palau', dial_code: '+680', code: 'PW', flag: '🇵🇼' },
	{ name: 'Palestinian Territory, Occupied', dial_code: '+970', code: 'PS', flag: '🇵🇸' },
	{ name: 'Panama', dial_code: '+507', code: 'PA', flag: '🇵🇦' },
	{ name: 'Papua New Guinea', dial_code: '+675', code: 'PG', flag: '🇵🇬' },
	{ name: 'Paraguay', dial_code: '+595', code: 'PY', flag: '🇵🇾' },
	{ name: 'Peru', dial_code: '+51', code: 'PE', flag: '🇵🇪' },
	{ name: 'Philippines', dial_code: '+63', code: 'PH', flag: '🇵🇭' },
	{ name: 'Pitcairn', dial_code: '+872', code: 'PN', flag: '🇵🇳' },
	{ name: 'Poland', dial_code: '+48', code: 'PL', flag: '🇵🇱' },
	{ name: 'Portugal', dial_code: '+351', code: 'PT', flag: '🇵🇹' },
	{
	  name: 'Puerto Rico',
	  dial_code: '+1939',
	  code: 'PR',
	  flag: '🇵🇷',
	  country_code: '+1',
	  area_codes: ['939', '787'],
	},
	{ name: 'Puerto Rico', dial_code: '+1787', code: 'PR2', flag: '🇵🇷', secondary: true },
	{ name: 'Qatar', dial_code: '+974', code: 'QA', flag: '🇶🇦' },
	{ name: 'Romania', dial_code: '+40', code: 'RO', flag: '🇷🇴' },
	{ name: 'Russia', dial_code: '+7', code: 'RU', flag: '🇷🇺' },
	{ name: 'Rwanda', dial_code: '+250', code: 'RW', flag: '🇷🇼' },
	{ name: 'Réunion', dial_code: '+262', code: 'RE', flag: '🇷🇪' },
	{ name: 'Saint Barthélemy', dial_code: '+590', code: 'BL', flag: '🇧🇱' },
	{
	  name: 'Saint Helena, Ascension and Tristan Da Cunha',
	  dial_code: '+290',
	  code: 'SH',
	  flag: '🇸🇭',
	},
	{ name: 'Saint Kitts and Nevis', dial_code: '+1869', code: 'KN', flag: '🇰🇳' },
	{ name: 'Saint Lucia', dial_code: '+1758', code: 'LC', flag: '🇱🇨' },
	{ name: 'Saint Martin', dial_code: '+590', code: 'MF', flag: '🇲🇫' },
	{ name: 'Saint Pierre and Miquelon', dial_code: '+508', code: 'PM', flag: '🇵🇲' },
	{ name: 'Saint Vincent and the Grenadines', dial_code: '+1784', code: 'VC', flag: '🇻🇨' },
	{ name: 'Samoa', dial_code: '+685', code: 'WS', flag: '🇼🇸' },
	{ name: 'San Marino', dial_code: '+378', code: 'SM', flag: '🇸🇲' },
	{ name: 'Sao Tome and Principe', dial_code: '+239', code: 'ST', flag: '🇸🇹' },
	{ name: 'Saudi Arabia', dial_code: '+966', code: 'SA', flag: '🇸🇦' },
	{ name: 'Senegal', dial_code: '+221', code: 'SN', flag: '🇸🇳' },
	{ name: 'Serbia', dial_code: '+381', code: 'RS', flag: '🇷🇸' },
	{ name: 'Seychelles', dial_code: '+248', code: 'SC', flag: '🇸🇨' },
	{ name: 'Sierra Leone', dial_code: '+232', code: 'SL', flag: '🇸🇱' },
	{ name: 'Singapore', dial_code: '+65', code: 'SG', flag: '🇸🇬' },
	{ name: 'Slovakia', dial_code: '+421', code: 'SK', flag: '🇸🇰' },
	{ name: 'Slovenia', dial_code: '+386', code: 'SI', flag: '🇸🇮' },
	{ name: 'Solomon Islands', dial_code: '+677', code: 'SB', flag: '🇸🇧' },
	{ name: 'Somalia', dial_code: '+252', code: 'SO', flag: '🇸🇴' },
	{ name: 'South Africa', dial_code: '+27', code: 'ZA', flag: '🇿🇦' },
	{
	  name: 'South Georgia and the South Sandwich Islands',
	  dial_code: '+500',
	  code: 'GS',
	  flag: '🇬🇸',
	},
	{ name: 'Spain', dial_code: '+34', code: 'ES', flag: '🇪🇸' },
	{ name: 'Sri Lanka', dial_code: '+94', code: 'LK', flag: '🇱🇰' },
	{ name: 'Sudan', dial_code: '+249', code: 'SD', flag: '🇸🇩' },
	{ name: 'South Sudan', dial_code: '+211', code: 'SS', flag: '🇸🇸' },
	{ name: 'Suriname', dial_code: '+597', code: 'SR', flag: '🇸🇷' },
	{ name: 'Svalbard and Jan Mayen', dial_code: '+47', code: 'SJ', flag: '🇸🇯' },
	{ name: 'Swaziland', dial_code: '+268', code: 'SZ', flag: '🇸🇿' },
	{ name: 'Sweden', dial_code: '+46', code: 'SE', flag: '🇸🇪' },
	{ name: 'Switzerland', dial_code: '+41', code: 'CH', flag: '🇨🇭' },
	{ name: 'Syrian Arab Republic', dial_code: '+963', code: 'SY', flag: '🇸🇾' },
	{ name: 'Sint Maarten', dial_code: '+721', code: 'SX', flag: '🇸🇽' },
	{ name: 'Taiwan, Province of China', dial_code: '+886', code: 'TW', flag: '🇹🇼' },
	{ name: 'Tajikistan', dial_code: '+992', code: 'TJ', flag: '🇹🇯' },
	{ name: 'Tanzania, United Republic of', dial_code: '+255', code: 'TZ', flag: '🇹🇿' },
	{ name: 'Thailand', dial_code: '+66', code: 'TH', flag: '🇹🇭' },
	{ name: 'Timor-Leste', dial_code: '+670', code: 'TL', flag: '🇹🇱' },
	{ name: 'Togo', dial_code: '+228', code: 'TG', flag: '🇹🇬' },
	{ name: 'Tokelau', dial_code: '+690', code: 'TK', flag: '🇹🇰' },
	{ name: 'Tonga', dial_code: '+676', code: 'TO', flag: '🇹🇴' },
	{ name: 'Trinidad and Tobago', dial_code: '+1868', code: 'TT', flag: '🇹🇹' },
	{ name: 'Tunisia', dial_code: '+216', code: 'TN', flag: '🇹🇳' },
	{ name: 'Turkey', dial_code: '+90', code: 'TR', flag: '🇹🇷' },
	{ name: 'Turkmenistan', dial_code: '+993', code: 'TM', flag: '🇹🇲' },
	{ name: 'Turks and Caicos Islands', dial_code: '+1649', code: 'TC', flag: '🇹🇨' },
	{ name: 'Tuvalu', dial_code: '+688', code: 'TV', flag: '🇹🇻' },
	{ name: 'Uganda', dial_code: '+256', code: 'UG', flag: '🇺🇬' },
	{ name: 'Ukraine', dial_code: '+380', code: 'UA', flag: '🇺🇦' },
	{ name: 'United Arab Emirates', dial_code: '+971', code: 'AE', preferred: true, flag: '🇦🇪' },
	{ name: 'United Kingdom', dial_code: '+44', code: 'GB', preferred: true, flag: '🇬🇧' },
	{ name: 'United States', dial_code: '+1', code: 'US', preferred: true, flag: '🇺🇸' },
	{ name: 'Uruguay', dial_code: '+598', code: 'UY', flag: '🇺🇾' },
	{ name: 'Uzbekistan', dial_code: '+998', code: 'UZ', flag: '🇺🇿' },
	{ name: 'Vanuatu', dial_code: '+678', code: 'VU', flag: '🇻🇺' },
	{ name: 'Venezuela, Bolivarian Republic of', dial_code: '+58', code: 'VE', flag: '🇻🇪' },
	{ name: 'Viet Nam', dial_code: '+84', code: 'VN', flag: '🇻🇳' },
	{ name: 'Virgin Islands, British', dial_code: '+1284', code: 'VG', flag: '🇻🇬' },
	{ name: 'Virgin Islands, U.S.', dial_code: '+1340', code: 'VI', flag: '🇻🇮' },
	{ name: 'Wallis and Futuna', dial_code: '+681', code: 'WF', flag: '🇼🇫' },
	{ name: 'Western Sarah', dial_code: '+212', code: 'EH', flag: '🇪🇭' },
	{ name: 'Yemen', dial_code: '+967', code: 'YE', flag: '🇾🇪' },
	{ name: 'Zambia', dial_code: '+260', code: 'ZM', flag: '🇿🇲' },
	{ name: 'Zimbabwe', dial_code: '+263', code: 'ZW', flag: '🇿🇼' },
	{ name: 'Åland Islands', dial_code: '+358', code: 'AX', flag: '🇦🇽' },
  ]
